import {Flex, ProgressBar} from 'exsportia-components'
import {FC, ReactElement, useCallback, useMemo, useState} from 'react'

import {SignUpForm} from '../../../services/auth/forms/sign-up-form'
import {AvatarSignUpStep} from './avatar-sign-up-step'
import {DobSignUpStep} from './dob-sign-up-step'
import {NameSignUpStep} from './name-sign-up-step'
import {PasswordSignUpStep} from './password-sign-up-step'
import {PhoneSignUpStep} from './phone-sign-up-step'

type SignUpStepProps = {
  email?: string
  venueId?: string
  backAction?: (e: Event) => void
  setModalTitle?: (title: ReactElement | string) => void
}

const progressBarSettings = {activeItem: {bg: 'primary'}}

const steps: FC<{
  handleGoToNextStep: () => void
  backAction?: (e: Event) => void
}>[] = [PasswordSignUpStep, NameSignUpStep, DobSignUpStep, PhoneSignUpStep, AvatarSignUpStep]

export const SignUpStep: FC<SignUpStepProps> = ({email, backAction, venueId}) => {
  const [step, setStep] = useState(0)
  const handleGoToNextStep = useCallback((index: number) => () => setStep(index + 1), [])
  const handleGoBack = useCallback((index: number) => () => setStep(index - 1), [])
  const stepsToUse = useMemo(
    () =>
      steps.map((Component, index) => (
        <Component
          handleGoToNextStep={handleGoToNextStep(index)}
          backAction={index === 0 ? backAction : handleGoBack(index)}
        />
      )),
    [],
  )

  return (
    <SignUpForm
      email={email}
      venueId={venueId}
    >
      <Flex
        flexDirection='column'
        gap='16px'
      >
        <ProgressBar
          total={steps.length}
          current={step}
          settings={progressBarSettings}
        />
        {stepsToUse[step]}
      </Flex>
    </SignUpForm>
  )
}
